import type { EditorElement } from '../../types';
import type { ComponentType, MutableRefObject } from 'react';
import type { ListToolbarMode, ListVariant } from './constants';
import type { CurrentActiveListVariantState } from './hooks/useCurrentList';

export const LIST_PLUGIN_ID = 'list' as const;
export type ListPluginID = typeof LIST_PLUGIN_ID;

export type ListPluginOptions = Readonly<{
  component?: ComponentType<any>;
  toolbarMode: ListToolbarMode;
  setCurrentActiveListVariant: (arg1: CurrentActiveListVariantState) => void;
  isReporterListFromLineBreakEnabled?: boolean;
}>;

export type ListPluginElement = Readonly<
  EditorElement & {
    type: ListPluginID;
    variant: ListVariant;
  }
>;

export type ListPluginPropertyOptions = Readonly<{
  pluginID: ListPluginID;
  component: ComponentType<any>;
  setCurrentActiveListVariant: (arg1: CurrentActiveListVariantState) => void;
  isReporterListFromLineBreakEnabled?: boolean;
  sendModifyDictationMessageRef?: MutableRefObject<Nullable<() => void>>;
}>;
